/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateCompanyInput = {
    name?: string | null | undefined;
    street?: string | null | undefined;
    zip?: string | null | undefined;
    city?: string | null | undefined;
    country?: string | null | undefined;
    currency?: string | null | undefined;
    timezone?: string | null | undefined;
    vatId?: string | null | undefined;
    logoId?: string | null | undefined;
    defaultRateCardId?: string | null | undefined;
    defaultHolidayCalendarId?: string | null | undefined;
    defaultExpenseCategoryId?: string | null | undefined;
    defaultRevenueMarginLow?: number | null | undefined;
    defaultRevenueMarginHigh?: number | null | undefined;
    disableNotifications?: boolean | null | undefined;
    timeRegNotificationSchedule?: string | null | undefined;
    projectOverviewNotificationSchedule?: string | null | undefined;
    contactPersonId?: string | null | undefined;
    contactName?: string | null | undefined;
    contactPhone?: string | null | undefined;
    contactEmail?: string | null | undefined;
    companyTarget?: number | null | undefined;
    monday?: number | null | undefined;
    tuesday?: number | null | undefined;
    wednesday?: number | null | undefined;
    thursday?: number | null | undefined;
    friday?: number | null | undefined;
    saturday?: number | null | undefined;
    sunday?: number | null | undefined;
    useTimeApproval?: boolean | null | undefined;
    useInternalTimeApproval?: boolean | null | undefined;
    useTimeOffApproval?: boolean | null | undefined;
    allUsersModifyTimeOff?: boolean | null | undefined;
    harvestDeactivate?: boolean | null | undefined;
    timelogDeactivate?: boolean | null | undefined;
    economicDeactivate?: boolean | null | undefined;
    slackDeactivate?: boolean | null | undefined;
    gitlabDeactivate?: boolean | null | undefined;
    gitlabServerDeactivate?: boolean | null | undefined;
    gitlabDeleteIssues?: boolean | null | undefined;
    calendarEnabled?: boolean | null | undefined;
    calendarApiEnabled?: boolean | null | undefined;
    outlookCalendarApiEnabled?: boolean | null | undefined;
    jiraServerUrl?: string | null | undefined;
    jiraPrefixType?: string | null | undefined;
    jiraServerPrefixType?: string | null | undefined;
    tempoOauthClientId?: string | null | undefined;
    tempoOauthClientSecret?: string | null | undefined;
    salesforceDeactivate?: boolean | null | undefined;
    salesforceAutoCreate?: boolean | null | undefined;
    xeroUninstall?: boolean | null | undefined;
    githubUnauthorizedInstallation?: number | null | undefined;
    githubDeactivate?: boolean | null | undefined;
    vstsDeactivate?: boolean | null | undefined;
    vstsEstimateField?: string | null | undefined;
    oktaClientId?: string | null | undefined;
    oktaClientSecret?: string | null | undefined;
    oktaUrl?: string | null | undefined;
    oktaDomainSuffix?: string | null | undefined;
    oneloginClientId?: string | null | undefined;
    oneloginClientSecret?: string | null | undefined;
    oneloginUrl?: string | null | undefined;
    unit4Enabled?: boolean | null | undefined;
    unit4TwoWay?: boolean | null | undefined;
    unit4SyncDateLimit?: string | null | undefined;
    AADClientId?: string | null | undefined;
    AADClientSecret?: string | null | undefined;
    AADTenant?: string | null | undefined;
    isUsingSchedulingPlanMode?: boolean | null | undefined;
    isUsingProjectAllocation?: boolean | null | undefined;
    isUsingMixedAllocation?: boolean | null | undefined;
    usingProjectAllocationCreateAllocations?: boolean | null | undefined;
    userSeats?: number | null | undefined;
    collaboratorSeats?: number | null | undefined;
    virtualSeats?: number | null | undefined;
    timesheetReminderDay?: string | null | undefined;
    timesheetReminderHour?: number | null | undefined;
    timesheetReminderEnabled?: boolean | null | undefined;
    timesheetReminderIncludeToday?: boolean | null | undefined;
    projectDigestNotificationDay?: string | null | undefined;
    projectDigestNotificationHour?: number | null | undefined;
    projectDigestNotificationEnabled?: boolean | null | undefined;
    userCanUnlinkInvoice?: boolean | null | undefined;
    skillLevelsEnabled?: boolean | null | undefined;
    revenueEnabled?: boolean | null | undefined;
    timesheetsEnabled?: boolean | null | undefined;
    clientsEnabled?: boolean | null | undefined;
    betaOptIn?: boolean | null | undefined;
    weekendDisplayPerUser?: boolean | null | undefined;
    weekendDisplayShowAlways?: boolean | null | undefined;
    invoiceQuantityDecimals?: number | null | undefined;
    addFeatureFlagKeysForCypress?: Array<string | null> | null | undefined;
    isSSOMandatory?: boolean | null | undefined;
    sageIntacctTimeRegsFromForecast?: boolean | null | undefined;
    sageIntacctSyncOnlyApproved?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateCompanySubscriptionDataMutationVariables = {
    input: UpdateCompanyInput;
};
export type updateCompanySubscriptionDataMutationResponse = {
    readonly updateCompany: {
        readonly company: {
            readonly id: string;
            readonly userSeats: number | null;
            readonly collaboratorSeats: number | null;
            readonly virtualSeats: number | null;
            readonly subscription: {
                readonly seats: number | null;
                readonly collaboratorSeats: number | null;
                readonly virtualSeats: number | null;
            } | null;
        } | null;
    } | null;
};
export type updateCompanySubscriptionDataMutation = {
    readonly response: updateCompanySubscriptionDataMutationResponse;
    readonly variables: updateCompanySubscriptionDataMutationVariables;
};



/*
mutation updateCompanySubscriptionDataMutation(
  $input: UpdateCompanyInput!
) {
  updateCompany(input: $input) {
    company {
      id
      userSeats
      collaboratorSeats
      virtualSeats
      subscription {
        seats
        collaboratorSeats
        virtualSeats
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCompanyInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSeats",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collaboratorSeats",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "virtualSeats",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seats",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanySubscriptionDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanyPayload",
        "kind": "LinkedField",
        "name": "updateCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanySubscriptionDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanyPayload",
        "kind": "LinkedField",
        "name": "updateCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCompanySubscriptionDataMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanySubscriptionDataMutation(\n  $input: UpdateCompanyInput!\n) {\n  updateCompany(input: $input) {\n    company {\n      id\n      userSeats\n      collaboratorSeats\n      virtualSeats\n      subscription {\n        seats\n        collaboratorSeats\n        virtualSeats\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fa53966c71db7d71d87b93280e1beea6';
export default node;
